import React, { type CSSProperties, useRef } from 'react';

import { Connector } from './Connector';
import type { ConnectorProps } from './Connector';
import { connectorTypesMap } from './connectorTypes';
import { useConnectorDrag } from './useConnectorDrag';
import { useConnectorRegister } from './useConnectorRegister';

export type ExecutionState = { type: string; [key: string]: unknown };

export interface ConnectorOutProps extends ConnectorProps {
  nodeId: string;
  cardRootRef: React.RefObject<HTMLElement>;
  activeConnectors: Set<string>;
  executionState: ExecutionState;
  positionStyle?: CSSProperties;
  isHovered?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  isDisabledStyle?: string;
  isVisibleOverride?: boolean;
  isDragOverAndCanConnect?: boolean;
}

export function ConnectorOut(props: ConnectorOutProps) {
  const circleRef = useRef<SVGCircleElement | null>(null);
  const connectorOutRef = useRef<HTMLDivElement | null>(null);

  const collectedProps = useConnectorDrag({
    ref: connectorOutRef,
    type: connectorTypesMap.Out,
    nodeId: props.nodeId,
    isDisabled: props.isDisabled,
  });

  useConnectorRegister({
    cardRootRef: props.cardRootRef,
    centerRef: circleRef,
    type: connectorTypesMap.Out,
    nodeId: props.nodeId,
    centerRefs: null,
  });

  const isActive = props.activeConnectors.has(`${props.nodeId}::${connectorTypesMap.Out}`);

  return (
    <Connector
      circleRef={circleRef}
      dragHandleRef={connectorOutRef}
      positionStyle={props.positionStyle}
      connectorType={connectorTypesMap.Out}
      executionState={props.executionState}
      isActive={isActive}
      isHovered={props.isHovered}
      isSelected={props.isSelected}
      isDisabled={props.isDisabled}
      isDisabledStyle={props.isDisabledStyle}
      isDragging={collectedProps?.isDragging}
      isVisibleOverride={props.isVisibleOverride}
      isDragOverAndCanConnect={props.isDragOverAndCanConnect}
      direction={props.direction}
    />
  );
}
